import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="forms--custom-form-raw-data"
export default class extends Controller {
  static targets = ["customForm"];
  static values = { customFormsUrl: String };

  connect() {
    this.customFormSelect = new TomSelect(this.customFormTarget, {
      valueField: "id",
      labelField: "title",
      searchField: "title",
      preload: true,
      load: (query, callback) => {
        if (this.loading > 1) {
          callback();
          return;
        }

        fetch(this.customFormsUrlValue)
          .then((response) => response.json())
          .then((json) => {
            callback(json);
          })
          .catch(() => {
            callback();
          });
      },
    });
  }
}
